module.exports = {"title":"Российский космос в 21 веке","description":"Российский космос ассоциируют с доставкой космонавтов на МКС. Но это лишь одна из длинного списка задач, которые выполняют Роскосмос и предприятия госкорпорации, чтобы изучить Землю, окружающие небесные тела и сделать жизнь на Земле более комфортной","image":"https://roscosmos.gazeta.ru/img/share.jpg","url":"https://roscosmos.gazeta.ru/","fbappid":396959934055666,"GTM":"GTM-KCXNRXN","top100":0,"clientTop100":0,"yaMetrika":0}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 330
// module chunks = 0